/**
 * Export state constants.
 *
 * @author    Naotoshi Fujita
 * @copyright Naotoshi Fujita. All rights reserved.
 */

/**
 * Splide has been just created.
 *
 * @type {number}
 */
export const CREATED = 1;

/**
 * All components have been mounted and initialized.
 *
 * @type {number}
 */
export const MOUNTED = 2;

/**
 * Splide is ready for transition.
 *
 * @type {number}
 */
export const IDLE = 3;

/**
 * Splide is moving.
 *
 * @type {number}
 */
export const MOVING = 4;

/**
 * Splide is moving.
 *
 * @type {number}
 */
export const DESTROYED = 5;